import React from 'react'

export const NodeContainerLoading = () => {
  return (
    <div className="position-fixed w-100 h-100 top-0 left-0 d-flex align-items-center justify-content-center" 
      style={{background: "rgba(255, 255, 255, 0.6)"}}>
        <div
          className="spinner-border"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}